export default {
  "content": "<circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#FFC67A\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.7 15.518a6.3 6.3 0 10-5.4 0v2.406h5.4v-2.406z\" fill=\"#fff\"/><path d=\"M12 20.625c.994 0 1.8-.403 1.8-.9s-.806-.9-1.8-.9-1.8.403-1.8.9.806.9 1.8.9z\" fill=\"#7D8392\"/><path d=\"M9.302 17.024H14.7v1.713c0 .544-.548.987-1.225.987h-2.95c-.675 0-1.225-.441-1.225-.987v-1.713h.002z\" fill=\"#989FAD\"/><path d=\"M12.5 7.875l-2 3h3l-2 3\" stroke=\"#FA4338\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};